
        <img *ngIf="entries[0] != null" [hidden]="hidden" [ngClass]="{hidden: entryIdx != 1}" [src]="entrySources[0]">
        <img *ngIf="entries[1] != null" [hidden]="hidden" [ngClass]="{hidden: entryIdx != 2}" [src]="entrySources[1]">
        <img *ngIf="entries[2] != null" [hidden]="hidden" [ngClass]="{hidden: entryIdx != 0}" [src]="entrySources[2]">
    